var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8858 7.06924V3.61636C20.8858 3.06408 20.438 2.61636 19.8858 2.61636H3.26465C2.71236 2.61636 2.26465 3.06408 2.26465 3.61636V26.8096C2.26465 27.3619 2.71236 27.8096 3.26465 27.8096H19.8858C20.438 27.8096 20.8858 27.3619 20.8858 26.8096V12.8824",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8858 7.06924V3.61636C20.8858 3.06408 20.438 2.61636 19.8858 2.61636H3.26465C2.71236 2.61636 2.26465 3.06408 2.26465 3.61636V26.8096C2.26465 27.3619 2.71236 27.8096 3.26465 27.8096H19.8858C20.438 27.8096 20.8858 27.3619 20.8858 26.8096V12.8824",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.05078,
    y1: 20.7374,
    x2: 17.0997,
    y2: 20.7374,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.05078,
    y1: 20.7374,
    x2: 17.0997,
    y2: 20.7374,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.05078,
    y1: 17.4515,
    x2: 17.0997,
    y2: 17.4515,
    stroke: "white",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.05078,
    y1: 17.4515,
    x2: 17.0997,
    y2: 17.4515,
    stroke: "white",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6.05078,
    y1: 24.0236,
    x2: 17.0997,
    y2: 24.0236,
    stroke: "white",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6.05078,
    y1: 24.0236,
    x2: 17.0997,
    y2: 24.0236,
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.21 5.88103L17.5245 16.5665L12.9629 18.6082C12.543 18.7962 12.1135 18.3651 12.3031 17.9458L14.3582 13.4016L25.0444 2.71545C25.9185 1.8413 27.3358 1.8413 28.21 2.71545C29.0841 3.5896 29.0841 5.00688 28.21 5.88103Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.21 5.88103L17.5245 16.5665L12.9629 18.6082C12.543 18.7962 12.1135 18.3651 12.3031 17.9458L14.3582 13.4016L25.0444 2.71545C25.9185 1.8413 27.3358 1.8413 28.21 2.71545C29.0841 3.5896 29.0841 5.00688 28.21 5.88103Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/draft-icon.290423b8cdaff4956ef6f4dfb5b94828.svg";
export { ForwardRef as ReactComponent };